// extracted by mini-css-extract-plugin
module.exports = {"sent":"CustomersTable_sent__357WG","link":"CustomersTable_link__1Vrj7"};